export default __webpack_public_path__ + "static/media/2022-ford-ranger-sport.220eacb4.png";